<template>
    <div>
        <b-tabs lazy :ref="'tabContainer'" :class="['tabContainer', {'tabContainer-desktop': device === 'desktop'}]">
            <b-tab v-for="(tab, index) in data"
                :key="index"
                :active="index == activeTab"
                @click.stop="setActive(tab, index)">
                <template v-slot:title>
                    <div class="tab-icon flex-box" ref="items">
                        <s-img :src="icon[index]" :alt="index" />
                        <span> {{index === 'tat-ca' ? 'TẤT CẢ' : $ALIAS_TYPE_GAME[index]}}</span>
                        <span v-if="index === 'ingame' || index === 'no-hu' && !isLabelEvent" class="menu-note animation">
                            <s-img src="/assets/img/header/icon-new.svg" alt="new"/>
                        </span>
                        <span v-if="index === 'game-bai' || index === 'no-hu-vegas'" class="menu-note animation">
                            <s-img src="/assets/img/header/icon-hot.svg" alt="hot"/>
                        </span>
                        <span v-if="index === 'ban-ca' && isLabelEvent" class="menu-note animation">
                            <s-img src="/assets/img/header/icon-event.svg" alt="event"/>
                        </span>
                    </div>
                </template>
                <div ref="gameContainer">
                    <div v-if="index === 'tat-ca'" :class="{'active': index == activeTab}">
                        <div class="wrap-game" v-for="(game, index) in data" :key="index">
                            <b-col v-if="game && game.items.length > 0" cols="12" class="section__title text-center">
                                <div class="start-title">
                                    <s-img src="/assets/img/line-star.png" alt="start"/>
                                </div>
                                <div class="heading h2"><span>{{$ALIAS_TYPE_GAME[index]}}</span></div>
                            </b-col>
                            <b-row v-if="game && game.items.length > 0" class="list-game">
                                <game-item v-for="(g, inx) in maxItem(game.items)" :key="inx" :item="g" />
                            </b-row>
                            <div v-if="game && game.items.length > 0 && index !== 'tat-ca'" class="section-readmore flex-box just-center">
                                <a href="javascript:void(0)" @click.prevent="setActive(tab, index)">XEM THÊM <i class="las la-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                    <div v-else :class="{'active': index == activeTab}">
                        <div class="wrap-game" v-if="tab && tab.items.length > maxItems">
                            <b-col cols="12" class="section__title text-center">
                                <div class="start-title">
                                    <s-img src="/assets/img/line-star.png" alt="start"/>
                                </div>
                                <div class="heading h2"><span>GAMES HOT</span></div>
                            </b-col>
                            <b-row class="list-game" v-if="tab && tab.items.length > 0">
                                <game-item v-for="(g, inx) in maxItem(tab.items)" :key="inx" :item="g" />
                            </b-row>
                        </div>
                        <div class="wrap-game" v-if="tab && tab.items.length > 0">
                            <b-col cols="12" class="section__title text-center">
                                <div class="start-title">
                                    <s-img src="/assets/img/line-star.png" alt="start"/>
                                </div>
                                <div class="heading h2"><span>GAMES PHỔ BIẾN</span></div>
                            </b-col>
                            <b-row class="list-game" v-if="tab && tab.items.length > 0">
                                <game-item v-for="(g, inx) in popularGame(tab.items)" :key="inx" :item="g" />
                            </b-row>
                        </div>
                    </div>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import gameItem from './gameItem.vue';

export default {
    props: ['data', 'icon', 'isShow', 'type', 'gameParentType'],
    components: {
        gameItem
    },
    data() {
        return {
            activeTab: {},
            isLoading: false,
            maxItems: this.$isMobile() ? 4 : 4
        };
    },
    computed: {
        device() {
            return this.$store.state.device;
        },
        isLabelEvent() {
            return process.env.ENABLE_LABEL_EVENT && process.env.ENABLE_LABEL_EVENT === '1';
        }
    },
    watch: {
        type(value) {
            this.activeTab = value;
            this.setScrollTab();
        }
    },
    methods: {
        maxItem(arr) {
            return arr.slice(0, this.maxItems);
        },
        popularGame(arr) {
            const arrLength = arr.length;
            if (arrLength > this.maxItems) return arr.slice(this.maxItems, arrLength);
            return arr;
        },
        setActive(tab, index) {
            this.activeTab = index;
            if (window.innerWidth <= 768) {
                this.$scrollTo('.sub-tabs', {
                    offset: -14
                });
            } else {
                this.$scrollTo('.sub-tabs', {
                    offset: 60
                });
            }
            this.$router.push({ query: { ...this.$getRoute(this.$route).query, type: index } });

            this.setFunctionButtonScroll();
        },
        async loadMoreGame(tab) {
            const {
                page, limit, type, display_type, totalPage
            } = tab;
            if (page === undefined) return;
            if (totalPage <= page) return;
            this.isLoading = true;
            const res = await this.$gameApi.getPage({
                page: page + 1,
                limit,
                type,
                display_type
            });
            if (res.status === 'OK' && res.data.items.length > 0) {
                this.data[this.activeTab].items = this.data[this.activeTab].items.concat(res.data.items);
                this.data[this.activeTab].page = res.data.page;
            }
            this.isLoading = false;
        },
        handleScroll(e) {
            if (window.innerWidth <= 768) {
                if (e && e.target.defaultView.scrollY > 180) {
                    $('.games-page').addClass('fix-tabsBar');
                } else {
                    $('.games-page').removeClass('fix-tabsBar');
                }
            } else if (e && e.target.defaultView.scrollY > 419) {
                $('.games-page').addClass('fix-tabsBar-pc');
            } else {
                $('.games-page').removeClass('fix-tabsBar-pc');
            }
            if (this.isShow && !this.isLoading) {
                const gameContainer = this.$refs.gameContainer[0];
                const gameBottom = gameContainer.getBoundingClientRect().top + gameContainer.clientHeight;
                if (window.innerHeight > gameBottom) {
                    if (this.data[this.activeTab]) {
                        this.loadMoreGame(this.data[this.activeTab]);
                    }
                }
            }
        },
        setScrollTab() {
            const itemIndex = Object.keys(this.data).findIndex((e) => e === this.activeTab);

            const tabWidth = this.$refs.tabContainer.$refs.nav.offsetWidth;
            const wrapTabWidth = this.$refs.tabContainer.$el.offsetWidth;
            if (tabWidth <= 0) {
                return true;
            }
            const centerPoint = wrapTabWidth / 2;
            const currentTabElement = this.$refs.tabContainer.$refs.nav.children[itemIndex];
            const currentCenterPoint = currentTabElement.offsetLeft + currentTabElement.offsetWidth / 2;

            // let scrollLeft = 0;
            const elementScroll = this.$isDesktop() ? $('.tabContainer .nav-tabs') : $('.tabContainer > div');

            if (currentCenterPoint <= centerPoint) {
                elementScroll.animate({ scrollLeft: 0 }, 200);
                return;
            }
            const scrollLeft = centerPoint - currentCenterPoint;
            elementScroll.animate({ scrollLeft: -(scrollLeft) }, 200);
        },
        setFunctionButtonScroll() {
            const itemIndex = Object.keys(this.data).findIndex((e) => e === this.activeTab);
            const elSliderTouchBack = $('.slider-touch__back');
            const elSliderTouchNext = $('.slider-touch__next');
            if (itemIndex > 5) {
                if (!elSliderTouchNext.hasClass('hide')) elSliderTouchNext.addClass('hide');
                if (elSliderTouchBack.hasClass('hide')) elSliderTouchBack.removeClass('hide');
            } else if (itemIndex < 3) {
                if (!elSliderTouchBack.hasClass('hide')) elSliderTouchBack.addClass('hide');
                if (elSliderTouchNext.hasClass('hide')) elSliderTouchNext.removeClass('hide');
            } else {
                $('.slider-touch').removeClass('hide');
            }
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.activeTab = this.type;
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted() {
        this.$nextTick(() => {
            // Scroll menu PC
            if (this.device === 'desktop') {
                const slider = document.querySelector('.tabContainer-desktop .nav-tabs');
                let isDown = false;
                let startX;
                let scrollLeft;

                if (slider) {
                    slider.addEventListener('mousedown', (e) => {
                        $('.nav-item').removeClass('disabledTab');
                        isDown = true;
                        startX = e.pageX - slider.offsetLeft;
                        scrollLeft = slider.scrollLeft;
                    });
                    slider.addEventListener('mouseleave', () => {
                        isDown = false;
                        $('.nav-item').removeClass('disabledTab');
                    });
                    slider.addEventListener('mouseup', () => {
                        isDown = false;
                        $('.nav-item').removeClass('disabledTab');
                    });
                    slider.addEventListener('mousemove', (e) => {
                        if (!isDown) return;
                        e.preventDefault();
                        const x = e.pageX - slider.offsetLeft;
                        const walk = x - startX;
                        slider.scrollLeft = scrollLeft - walk;
                        $(e.target).closest('.nav-item').addClass('disabledTab');

                        // Check display arrow
                        const tabWidth = this.$refs.tabContainer.$refs.nav.offsetWidth;
                        const menuLastItemLeft = $('.tabContainer-desktop .nav-tabs').find('li').last().position().left + 150;
                        const menuFirstItemLeft = $('.tabContainer-desktop .nav-tabs').find('li').first().position().left;
                        if (menuFirstItemLeft > 0) {
                            $('.slider-touch__back').addClass('hide');
                        } else {
                            $('.slider-touch__back').removeClass('hide');
                        }
                        if (tabWidth > menuLastItemLeft) {
                            $('.slider-touch__next').addClass('hide');
                        } else {
                            $('.slider-touch__next').removeClass('hide');
                        }
                    });
                }

                // check display button scroll
                if (this.gameParentType !== 'vegas') {
                    const elSliderTouch = $('.slider-touch');
                    // Append button scroll
                    if (!elSliderTouch.length) {
                        const img = `${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/icon-arrow-scroll.svg`;
                        $('.tabContainer-desktop > div:first-child').append(`<div class="slider-touch slider-touch__next" id="slider-touch"><img src="${img}"></div>`);
                        $('.tabContainer-desktop > div:first-child').append(`<div class="slider-touch slider-touch__back" id="slider-touch__back"><img src="${img}"></div>`);
                    }
                }

                // Button scroll action
                const elSliderTouchBack = $('.slider-touch__back');
                const elSliderTouchNext = $('.slider-touch__next');

                elSliderTouchBack.click(() => {
                    $('.tabContainer .nav-tabs').animate({ scrollLeft: 0 }, 500);
                    if (!elSliderTouchBack.hasClass('hide')) elSliderTouchBack.addClass('hide');
                    elSliderTouchNext.removeClass('hide');
                });
                elSliderTouchNext.click(() => {
                    $('.tabContainer .nav-tabs').animate({ scrollLeft: 500 }, 500);
                    if (!elSliderTouchNext.hasClass('hide')) elSliderTouchNext.addClass('hide');
                    elSliderTouchBack.removeClass('hide');
                });

                // Check action scroll when mounted component
                this.setFunctionButtonScroll();
            }

            setTimeout(() => {
                this.setScrollTab();
            }, 100);
        });
        // window.addEventListener('resize', this.setScrollTab);
    }
};
</script>
